// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const shelgon: PokeData = {
  "id": 372,
  "name": "shelgon",
  "height": 11,
  "weight": 1105,
  "base_experience": 147,
  "types": [
    PokeType.DRAGON
  ],
  "api_moves": [
    "headbutt",
    "double-edge",
    "leer",
    "bite",
    "ember",
    "flamethrower",
    "rage",
    "focus-energy",
    "protect",
    "scary-face",
    "outrage",
    "dragon-breath",
    "crunch",
    "dragon-claw",
    "zen-headbutt"
  ],
  "moves": [
    "headbutt",
    "leer",
    "bite",
    "ember",
    "flamethrower",
    "protect",
    "scary-face",
    "outrage",
    "dragon-breath",
    "crunch",
    "dragon-claw",
    "zen-headbutt",
    "dragon-dance"
  ],
  "evolution_chain": {
    "id": 191,
    "item": null,
    "species": [
      {
        "name": "bagon",
        "order": 401,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "shelgon",
        "order": 402,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 371,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "salamence",
        "order": 403,
        "types": [
          PokeType.DRAGON,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 372,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 50,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 70,
    "speed": 50,
    "ability_power": 95
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
